import { useEffect } from "react"
import { useApplication } from "../../../store/application/hooks"
import { Models } from "../../viewer/renderer.api"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router"
import { useSlopedRoof } from "../../../store/sloped-roof/hooks"
import { renderer } from "../../viewer/Renderer"
import { useRoutes } from "../../../store/routes/hooks"

export function useRoofType() {
  const { currentModel, directLink, setDirectLink } = useApplication()
  const { Routes } = useRoutes() as any
  const { t } = useTranslation() as any
  const history = useHistory()
  const {
    configurationState,
    setSlopedRoofTypeType: setSlopedRoofTypeTypeState,
  } = useSlopedRoof()

  const slopedRoofTypeType = configurationState.roofType.type
  const nextButtonDisabled = !slopedRoofTypeType

  useEffect(() => {
    if (renderer && currentModel === Models.DOLLHOUSE && directLink) {
      setDirectLink(false)
      renderer.displayModel(Models.SLOPED_ROOF).then(() => renderer.hideMarkers())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleNextButtonClick() {
    history.push(Routes.SLOPED_ROOF_2_ROOF_INSULATION)
  }

  function setSlopedRoofTypeType(type: any) {
    setSlopedRoofTypeTypeState(type)
    renderer.displaySlopedRoofType(type)
  }

  return {
    t,
    slopedRoofTypeType,
    setSlopedRoofTypeType,
    handleNextButtonClick,
    nextButtonDisabled,
  }
}
